module.exports = __webpack_public_path__ + "img/mt.ba194ac4.svg";